<app-instance-info-section></app-instance-info-section>
<div class="row" style="width: 100%; margin: 10px 0px">
    <div class="col-md-3">
        <app-hierarchy-idms-views [idmsView]="idmsView" [instanceId]="instanceId" [isCreate]="isCreate"
            [idmstagItem]="idmstagItem" (updatePayload)="updateViewsSelection($event)"></app-hierarchy-idms-views>
    </div>

    <div class="col-md-9">
        <div class="card card-custom gutter-b card-stretch">
            <div class="idms_view_title">
                <h3 *ngIf="isSaveOnce">Select Hierarchy</h3>
                <h3 *ngIf="!isSaveOnce">Hierarchy</h3>
                <div class="custom-selection-wrapper">
                    <div class="hierarchy_selection">
                        <mat-select name="Hierarchy" placeholder="Select" (selectionChange)="HierarchyChange()"
                            [(ngModel)]="selectedHierarchy" *ngIf="isSaveOnce" class="dropdown-wrapper"
                            panelClass="dropdown-wrapper">
                            <ng-container *transloco="let t; read: 'ORG_DETAILS.COUNTRY'">
                                <mat-option class="option-list" [value]="c"
                                    *ngFor="let c of dropDownList; let i = index">{{ c.name }} </mat-option>
                            </ng-container>
                        </mat-select>
                    </div>
                    <!-- *ngIf="isSaveOnce" -->
                    <div *ngIf="isSaveOnce">
                        <button class="btn primary-ebtn"
                            [disabled]="isCustomOnce && selectedHierarchy && selectedHierarchy.name != 'Custom Hierarchy'"
                            (click)="customHierarchy()" *ngIf="!isCustomClick">
                            Design Hierarchy
                        </button>
                        <button class="btn primary-ebtn" *ngIf="isCustomClick" (click)="UseHierarchy()">Use
                            Hierarchy</button>
                    </div>
                </div>
            </div>

            <div class="hierarchy_view_section">
                <div *ngIf="idmstagItem?.length == 0 && !isCustomClick">
                    <h2 class="title1">Select your hierarchy to configure</h2>
                </div>

                <div *ngIf="idmstagItem && !isCustomClick">
                    <app-hierarchy-option *ngIf="idmstagItem?.length > 0" (triggerSaveEvent)="saveInstanceViews($event)"
                        [isCreate]="isCreate" [idmstagItem]="idmstagItem" [idmsHierarchy]="idmsHierarchy"
                        [selectedHierarchy]="selectedHierarchy" (resultedIdmsTagList)="resultListHandler($event)"
                        [instanceId]="instanceId"></app-hierarchy-option>
                </div>

                <div *ngIf="isCustomClick && taggedItemsTypes?.length">
                    <app-flowchart [taggedItemsTypes]="taggedItemsTypes" (genratedHierarchy)="genratedHierarchy($event)"
                        [customHiearchy]="customHiearchy" [diagramJson]="diagramJson"></app-flowchart>
                </div>
            </div>
        </div>
    </div>
</div>